
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';
import SectionHeading from '@/components/ui/section-heading';

interface InstallationStep {
  number: string;
  title: string;
  description: string;
}

const installationSteps: InstallationStep[] = [
  {
    number: "1",
    title: "Site Assessment",
    description: "Work with you to map critical zones and vulnerabilities."
  }, 
  {
    number: "2",
    title: "Precision Trenching",
    description: "Gently bury cables along your perimeter, preserving terrain (lawns, roads, or soil)."
  }, 
  {
    number: "3",
    title: "AI Calibration",
    description: "Adjust sensitivity levels at the on-site control unit for your environment."
  }, 
  {
    number: "4",
    title: "Comprehensive Overview",
    description: "Provide guidance on how the system works and connect with monitoring platform for in depth usage details."
  }, 
  {
    number: "5",
    title: "Routine Maintenance",
    description: "Annual checks via the indoor terminal ensure uninterrupted protection."
  }
];

const FibreInstallation = () => {
  return (
    <section aria-labelledby="installation-heading" className="section bg-forti-fi-background py-[59px] bg-[#afffce]/[0.16]">
      <div className="container mx-auto">
        <SectionHeading 
          title="How We Install It"
          className="text-center mb-8"
          titleClassName="text-forti-fi-teal"
        />
        
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            {/* Left side - Text content */}
            <div className="md:col-span-5">
              {installationSteps.map((step, index) => (
                <div key={index} className="mb-12 last:mb-0 text-left pr-8">
                  <h3 className="text-xl font-serif text-forti-fi-teal mb-2 flex items-center">
                    <span>{step.number}. {step.title}</span>
                  </h3>
                  <p className="text-forti-fi-charcoal">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>

            {/* Middle - Timeline with numbers and connecting lines */}
            <div className="hidden md:block md:col-span-2">
              <div className="relative h-full flex flex-col items-center justify-between py-4">
                {/* Vertical line connecting all points */}
                <div className="absolute top-10 bottom-10 w-0.5 bg-forti-fi-teal/60"></div>
                
                {/* Timeline points with numbers */}
                {installationSteps.map(step => (
                  <div key={step.number} className="relative z-10 flex items-center justify-center mb-auto mt-auto">
                    <div className="flex items-center justify-center w-10 h-10 bg-forti-fi-teal rounded-full text-white font-medium">
                      {step.number}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Right side - Image */}
            <div className="md:col-span-5 flex items-center justify-center">
              <div className="bg-white rounded-lg overflow-hidden shadow-md h-full w-full">
                <img alt="Fiber Installation Process" className="w-full h-full object-cover" loading="lazy" src="/images/Solutions Fibre Overview Section 2.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FibreInstallation;
